import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VLFCard from "@/components/Card";
import Button from "@mui/material/Button";
import ViewField from "@/components/Input/ViewField";
import CardsList from "@/components/CardsList";
import VLFModal from "@/components/Modal";

import {RosterAPI} from "@/api/roster";

import ArrowBack from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {
	ERROR_OPERATION,
	SUCCESSFUL_OPERATION,
	playerRoles,
} from "@/utils/constants";

import "./index.scss";

const ScoutingRosterPage = (props) => {
	const {handleNotification} = props;

	const navigate = useNavigate();
	const {id} = useParams();

	const [loading, setLoading] = useState(false);
	const [roster, setRoster] = useState();

	const [openHandleConfirm, setOpenHandleConfirm] = useState(false);

	const getRoster = async () => {
		setLoading(true);
		try {
			const response = await RosterAPI.getById(id);
			setRoster(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	const deleteRoster = async () => {
		setLoading(true);
		try {
			await RosterAPI.delete(id);
			handleNotification(SUCCESSFUL_OPERATION, "success");
			navigate("/development/rosters");
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
			setLoading(false);
		} finally {
			setOpenHandleConfirm(false);
		}
	};

	useEffect(() => {
		getRoster();
	}, []);

	const goBack = () => {
		navigate("/development/rosters");
	};


	const mainConfiguration = [
		{
			value: roster?.season?.name,
			label: "Stagione",
			size: "col-6 col-lg-4",
		},
		// {
		// 	value: roster?.name,
		// 	label: "Nome",
		// 	size: "col-6 col-lg-4",
		// },
		{
			value: roster?.playerCategory?.name,
			label: "Categoria",
			size: "col-6 col-lg-4",
		},
	];

	const groupedPlayers = {};
	playerRoles.forEach((pr) => {
		const roleLabel = pr.groupLabel;
		const roleId = pr.value;
		const playersMembers = roster?.players?.filter(
			(p) =>
				(p.player?.goalkeeper && roleId === "Portiere") ||
				p.player?.primaryRole === roleId,
		);
		groupedPlayers[roleLabel] = playersMembers;
	});

	const playersListConfiguration = {
		data: groupedPlayers,
		onClick: (player) =>
			!player?.player?.prospect
				? navigate("/players/" + player?.player?.id)
				: navigate("/scouting/players/" + player?.player?.id),
		separator: false,
	};

	const staffListConfiguration = {
		data: roster?.staff,
		onClick: (staff) =>
			!staff?.staff.prospect
				? navigate("/manager/staffs/" + staff?.staff.id)
				: navigate("/scouting/staffs/" + staff?.staff.id),
	};

	let mainActions = [
		{
			icon: <ArrowBack />,
			title: "Indietro",
			onClick: goBack,
			color: "info",
		},
		{
			icon: <EditIcon />,
			title: "Modifica",
			onClick: () => navigate("/development/rosters/" + roster?.id + "/edit"),
		},
		{
			icon: <DeleteIcon />,
			title: "Elimina",
			onClick: () => setOpenHandleConfirm(true),
			color: "error",
		},
	];

	const breadcrumbsElements = [
		{label: "Roster", path: "/development/rosters"},
		{label: "/"},
	];

	return (
		<Page className="scouting-roster-page player-container">
			<Loading visible={loading} />
			<Breadcrumbs
				elements={breadcrumbsElements}
				current={roster ? roster.name : ""}
				actions={<MainActions actions={mainActions} />}
			/>
			<div className="row no-margin">
				<div className="col-sm-12 padding-small">
					<VLFCard
						title="Informazioni principali"
						content={
							<div className="row">
								<div className="col-sm-12">
									<ViewField configuration={mainConfiguration} />
								</div>
							</div>
						}
						openable={false}
					/>
				</div>
			</div>
			<div className="row no-margin mt-3">
				<div className="col-sm-12 padding-small">
					<div className="block-title-container d-flex align-items-center justify-content-between">
						<div className="block-title f-bold padding-small">Giocatori</div>
						<Button
							variant="contained"
							onClick={() => {
								navigate("/development/rosters/" + id + "/players");
							}}
							size="small"
						>
							<div className="d-flex align-items-center">
								<div>Modifica</div>
							</div>
						</Button>
					</div>
					<div className="block-items-container">
						<CardsList
							type="roster_player"
							grouped
							listConfiguration={playersListConfiguration}
							groupSorted={false}
						/>
					</div>
				</div>
			</div>
			<div className="row no-margin mt-3">
				<div className="col-sm-12 padding-small">
					<div className="block-title-container d-flex align-items-center justify-content-between">
						<div className="block-title f-bold padding-small">Staff</div>
						<Button
							variant="contained"
							onClick={() => {
								navigate("/development/rosters/" + id + "/staffs");
							}}
							size="small"
						>
							<div className="d-flex align-items-center">
								<div>Modifica</div>
							</div>
						</Button>
					</div>
					<div className="block-items-container">
						<CardsList
							type="roster_staff"
							listConfiguration={staffListConfiguration}
							defaultSortedField="lastName"
						/>
					</div>
				</div>
			</div>

			<VLFModal
				open={openHandleConfirm}
				title="Eliminazione"
				content={
					<div className="mt-2">
						Sei sicuro di voler eliminare questo elemento?
					</div>
				}
				confirm={() => {
					deleteRoster();
				}}
				close={() => setOpenHandleConfirm(false)}
				confirmLabel="Conferma"
			/>
		</Page>
	);
};

export default ScoutingRosterPage;
